import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Box from '../../../components/Box';
import { RootState } from '../../../redux/store';
import { DURUM, MUTABAKAT_SAYFASI, MutabakatOzeti, tl, YurticiMutabakatService } from '../../../services/YurticiMutabakatService';

const tones: any = { success: '#50cd89', warning: '#f1bc00', danger: '#f1416c', info: '#7239ea', gray: '#a1a5b7' };

/**
 * Dashboard > Yurtiçi Kargo: gider mutabakatı kartları (24.10.2026, #485). Yalnız "Gider Mutabakatı" yetkisi olana görünür;
 * sayılara yalnız incelenmemiş kayıtlar girer. Karta tıklayınca mutabakat ekranı o durum sekmesiyle açılır. Kendi verisini
 * ayrıca çeker; modül dashboard'unun tarih aralığından etkilenmez.
 */
const YurticiMutabakatKartlari = () => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth);
    const yetkili = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == MUTABAKAT_SAYFASI);
    const [ozet, setOzet] = useState<MutabakatOzeti | undefined>(undefined);

    useEffect(() => {
        if (!yetkili)
            return;

        YurticiMutabakatService.ozet()
            .then(r => { if (r.isSuccess) setOzet(r.data); })
            .catch(() => { });
    }, [yetkili])

    if (!yetkili || !ozet)
        return null;

    const ac = (durum: number | undefined) => navigate('/yurticimutabakat/list', { state: { durum } });
    const eskiRapor = ozet.sonRaporGun == null || ozet.sonRaporGun > 8;

    const kart = (anahtar: string, etiket: string, deger: React.ReactNode, ton: string, ipucu: string | undefined, durum: number | undefined | null) => (
        <Box key={anahtar} flex='1 1 200px' minWidth='200px'>
            <Box
                onClick={durum !== null ? () => ac(durum ?? undefined) : undefined}
                className={durum !== null ? 'actionIcon' : undefined}
                bg='#ffffff'
                p='18px 20px'
                borderRadius='8px'
                borderLeft={'4px solid ' + tones[ton]}
                boxShadow='0 2px 8px rgba(0, 0, 0, 0.05)'
                height='100%'
            >
                <Box className='text-gray-600' mb='8px'>{etiket}</Box>
                <h1 className='m-0 p-0' style={{ fontSize: 30, fontWeight: 700 }}>{deger}</h1>
                {ipucu && <Box className='text-gray-500' mt='6px'>{ipucu}</Box>}
            </Box>
        </Box>
    );

    return (
        <React.Fragment>
            <Box mt='24px' mb='10px' flexDirection='row' alignItems='center' gap='10px'>
                <h4 className='m-0 p-0'>Gider mutabakatı</h4>
                <Box className='text-gray-500'>Yurtiçi faturası ile beklenen gider (KDV hariç); incelenmemiş kayıtlar</Box>
            </Box>

            <Box flexDirection='row' gap='16px' flexWrap='wrap'>
                {kart('fark', 'Tutar farklı', ozet.tutarFarkli.toLocaleString('tr-TR'), ozet.tutarFarkli > 0 ? 'danger' : 'success',
                    ozet.tutarFarkli > 0 ? 'Toplam fark ' + tl(ozet.tutarFarkliToplam) + ' (artı ' + tl(ozet.artiFark) + ', eksi ' + tl(ozet.eksiFark) + ')' : undefined, DURUM.TUTAR_FARKLI)}
                {kart('yok', "Keylogx'te yok", ozet.keylogxteYok.toLocaleString('tr-TR'), ozet.keylogxteYok > 0 ? 'warning' : 'success', 'Faturada var, Keylogx\'te gönderi yok', DURUM.KEYLOGXTE_YOK)}
                {kart('rapor', 'Raporda yok', ozet.rapordaYok.toLocaleString('tr-TR'), ozet.rapordaYok > 0 ? 'info' : 'success', '14 günü geçti, hiçbir faturada çıkmadı', DURUM.RAPORDA_YOK)}
                {kart('oran', 'Mutabakat oranı', ozet.mutabakatOrani == null ? '—' : '%' + ozet.mutabakatOrani.toLocaleString('tr-TR'), 'success',
                    ozet.eslesen.toLocaleString('tr-TR') + ' / ' + ozet.karsilastirilan.toLocaleString('tr-TR') + ' gönderi eşleşti', DURUM.ESLESTI)}
                {kart('son', 'Son başarılı rapor', ozet.sonBasariliRapor ?? 'Henüz yok', eskiRapor ? 'warning' : 'gray',
                    eskiRapor ? 'Rapor 8 günden eski; mail kutusu ve Çalışma Geçmişi\'ni kontrol edin' : undefined, null)}
            </Box>
        </React.Fragment>
    )
}

export default YurticiMutabakatKartlari;
